import React, { Component } from 'react';
import { FAQ, FAQCategory } from '@app/models/zesty.model';
import {
  Button,
  IconMail,
  Accordion,
  AccordionSection,
  Panel,
  Link,
} from '@ftdr/blueprint-components-react';
import Path from '@constants/paths';
import { fireGAEvent } from '@app/core/tracking.service';
import { FAQ__CONTACT_US } from '@constants/ga-events.constants';
import REText from '@components/wrappedBDS/REText';
import withRouter, { RouterProps } from '@helpers/withRouter';
import { GetPath } from '@helpers/path.utils';
import { getCurrentThemeConfig } from '@app/core/theme-config';

interface state {}

interface props {
  FAQs: FAQ[];
  FAQCategories: FAQCategory[];
  RoleIDType: string;
  router: RouterProps
}

class FAQTemplate extends Component<props, state> {
  elementRefs = [];

  constructor(props) {
    super(props);
    this.state = {};
  }

  createRef = (element, id) => {
    this.elementRefs[id] = element;
  };

  handleQuestion = (id) => {
    this.elementRefs[id].scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  };

  sortByField = (a, b) => {
    return a.sort - b.sort;
  };

  handleRequestSupport = (e) => {
    console.info('navigating to contact-us page');
    fireGAEvent(FAQ__CONTACT_US(this.props.RoleIDType));
    window.location.assign(GetPath(Path.ContactUs));
  };

  render() {
    return (
      <div className="px-0 mx-0">
        <Panel
          className={getCurrentThemeConfig().faqPanelClass}
          rounded={getCurrentThemeConfig().faqPanelRoundedSize}
          padding="none"
          shadow={getCurrentThemeConfig().faqPanelShadow}
          border="0"
        >
          <div
            className={`${getCurrentThemeConfig().faqStickyMenuClass} prewrap`}
            style={{ position: 'sticky' }}
          >
            <Accordion mode="multiple" hideFirstSeparator>
              {this.props.FAQCategories.sort(this.sortByField).map((category) => (
                <AccordionSection
                  key={category.id}
                  label={category.name}
                  className="shadow-none text-interactive-color pl-2"
                >
                  <ul className="ml-3 p-4">
                    {this.props.FAQs.filter((faq) => faq.categoryID === category.id)
                      .sort(this.sortByField)
                      .map((faq) => (
                        <li key={faq.id} className="prewrap mb-4">
                          <Link
                            className="font-bold"
                            color="interactive"
                            onClick={() => this.handleQuestion(faq.id)}
                          >
                            {faq.question}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </AccordionSection>
              ))}
            </Accordion>
            <div
              className={`${getCurrentThemeConfig().faqStickyMenuButton} relative text-left block`}
            >
              <Button
                id="request_support_nav"
                onClick={this.handleRequestSupport}
                size="small"
                width="full"
                label="Request Support"
                startIcon={<IconMail />}
                shape={getCurrentThemeConfig().buttonThemeShape}
                color={getCurrentThemeConfig().faqButtonColor}
              />
            </div>
          </div>
          <div className={getCurrentThemeConfig().faqCategoriesContainerClass}>
            {this.props.FAQCategories.sort(this.sortByField).map((category) => (
              <div key={category.id} className="mb-4">
                <REText id={'lbl-category-' + category.id} variant="heading-03">
                  {category.name}
                </REText>
                {this.props.FAQs.filter((faq) => faq.categoryID === category.id)
                  .sort(this.sortByField)
                  .map((faq) => (
                    <div
                      id={faq.id}
                      key={faq.id}
                      ref={(element) => this.createRef(element, faq.id)}
                    >
                      <REText
                        id={'lbl-question-' + faq.id}
                        variant="heading-06"
                        className="mt-4 mb-2 normal-case"
                      >
                        {faq.question}
                      </REText>
                      <div
                        className="zesty-html"
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      />
                    </div>
                  ))}
              </div>
            ))}
            <REText
              variant={getCurrentThemeConfig().faqStillHaveQuestionsVariant}
              className={getCurrentThemeConfig().faqStillHaveQuestionsClass}
            >
              Still have questions?
            </REText>
            <REText className={getCurrentThemeConfig().faqSubmitRequestClass}>
              Submit a support request.
            </REText>
            <Button
              className={getCurrentThemeConfig().faqRequestSupportButtonClass}
              id="request_support_content"
              onClick={this.handleRequestSupport}
              size="small"
              label="Request Support"
              startIcon={<IconMail />}
              shape={getCurrentThemeConfig().buttonThemeShape}
              color={getCurrentThemeConfig().faqButtonColor}
            />
          </div>
        </Panel>
      </div>
    );
  }
}

export default withRouter(FAQTemplate);
